/**
 * Shared MQTT helpers for remote v2.
 */

export interface MqttClientLike {
  connected?: boolean;
  subscribe: (topic: string) => void;
  publish: (
    topic: string,
    payload: string,
    options?: { retain?: boolean; qos?: number },
    cb?: (err?: Error) => void
  ) => void;
  end?: (force?: boolean) => void;
  on: (event: string, handler: (...args: unknown[]) => void) => void;
}

interface MqttNamespaceLike {
  connect: (url: string, options?: Record<string, unknown>) => MqttClientLike;
}

const MQTT_CDN_URL = 'https://unpkg.com/mqtt@5.3.0/dist/mqtt.min.js';
let mqttScriptPromise: Promise<void> | null = null;

function hasMqttGlobal(): boolean {
  return typeof (window as unknown as { mqtt?: unknown }).mqtt !== 'undefined';
}

export function ensureMqttGlobal(): Promise<void> {
  if (hasMqttGlobal()) return Promise.resolve();
  if (mqttScriptPromise) return mqttScriptPromise;
  mqttScriptPromise = new Promise((resolve, reject) => {
    const script = document.createElement('script');
    script.src = MQTT_CDN_URL;
    script.async = true;
    script.onload = () => resolve();
    script.onerror = () => reject(new Error('Failed to load MQTT runtime'));
    document.head.appendChild(script);
  });
  return mqttScriptPromise;
}

export function getMqttNamespace(): MqttNamespaceLike | null {
  const ns = (window as unknown as { mqtt?: unknown }).mqtt;
  return ns && typeof (ns as { connect?: unknown }).connect === 'function'
    ? (ns as MqttNamespaceLike)
    : null;
}
